import MainPageLayout from "../../../layout/MainPageLayout";
import RegistrationContainer from "../forms/registration/RegistrationContainer";

const RegisterCylinderPage = () => {
  return (
    <MainPageLayout headerConfig={{ title: "Cylinder Registered" }}>
      <RegistrationContainer />
    </MainPageLayout>
  );
};

export default RegisterCylinderPage;
